export const contentCode = {
    ABOUT: 'about',
    PRIVACY: 'privacy',
    TERMS: 'terms',
    PAY_STATEMENT: 'pay_statement',
    GIFT_GUIDE_STATEMENT: 'gift_guide',
    GIFT_GUIDE_DESC: 'gift_guide_desc',
    COOKIE_STATEMENT: 'cookie_statement',
    WINTER_SHOPPING_GUIDE: 'winter_shopping_guide',
}